import { ListItemLink } from './menu.styles';

import useAccountPermission from '../../../hooks/useAccountPermission';

import type { AccountRolePermissions } from '@rewardopl/types';
import type { NavLink } from 'react-router-dom';

type PermissionListItemLinkProps = React.ComponentPropsWithoutRef<typeof NavLink> & {
  permission: keyof AccountRolePermissions;
};

export default function PermissionListItemLink({
  permission,
  ...otherProps
}: PermissionListItemLinkProps) {
  const isAuthorized = useAccountPermission(permission);

  if (!isAuthorized) {
    return null;
  }

  return <ListItemLink {...otherProps} />;
}
